import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useQuery, useMutation } from '@tanstack/react-query';

import { 
  
} from './api';

import './styles.css';

import useAuth from '../../../auth/useAuth';

import Layout from '../../UI/introGameLayout/layout';

import { 
  coursesQuery,
  tournamentsQuery,
  tournamentsRoundsQuery,
  updateTournamentsRounds
} from './api';

import CompetitionHeader from '../../UI/instructor/onboarding/reviewSession/competitionHeader';
import CompetitionFooter from '../../UI/instructor/onboarding/reviewSession/competitionFooter';

import ReviewsSessionExerciseTable from '../../UI/reviewSession/exerciseTable';
import Alert from '../../UI/alert';

export default function InstructorOnboardingAssignExercise() {
  const navigate = useNavigate();

  const { getTournamentGames } = useAuth();
  const tournamentGames = getTournamentGames() || [];
  
  const [latestTournament, setLatestTournament] = useState(null);
  const [roundRows, setRoundRows] = useState([]);
  const [isAlertVisible, setIsAlertVisible] = useState(false);

  const { data: courses } = useQuery(coursesQuery());

  const { data: tournaments } = useQuery(tournamentsQuery('assign-exercise'));
  const { data: tournamentsRounds } = useQuery(tournamentsRoundsQuery({tournamentId: latestTournament?.id}));

  const updateTournamentsRoundsMutation = useMutation({
    mutationFn: (data) => updateTournamentsRounds(data)
  });

  const getRoundRows = (roundCount) => {
    const rounds = ['Sweet 16', 'Elite 8', 'Final 4', 'Championship'];
    const ordinals = ['First', 'Second', 'Third', 'Final'];
    
    return rounds
      .slice(4 - roundCount)
      .map((name, i, arr) => {
        const order = i === arr.length - 1 ? 'Final' : ordinals[i];
        return { 
          name: `${order} Round`, 
          stage: `(${name})`, 
          gameId: null, 
          index: i + 1,
          updated: false
        };
      });
  };

  useEffect(() => {
    if(courses?.length > 0 && tournaments?.length > 0) {
      const courseId = courses[0].id;

      const courseTournaments = tournaments.filter(tournament => tournament.course_id === courseId);
      const latestTournament = courseTournaments.reduce((max, tournament) => tournament.id > max.id ? tournament : max, courseTournaments[0]);

      const roundCount = latestTournament.round_count;
      const roundRows = getRoundRows(roundCount);
      setLatestTournament(latestTournament);
      setRoundRows(roundRows);
    }
  }, [courses, tournaments]);

  const handleBackButtonClick = () => {
    navigate('/instructor/onboarding-review-session/competition');
  }

  const handleImDoneButtonClick = () => {
    const hasNotSelectedRound = roundRows.some(roundRow => !roundRow.updated);
    if(hasNotSelectedRound) {
      setIsAlertVisible(true);
    } else {
      navigate('/instructor/settings/assignments');
    }
  }


  const handleGameSelectChange = (game, row) => {
    setRoundRows(prev =>
      prev.map(r =>
        r.name === row.name ? { ...r, gameId: game.id } : r
      )
    );
  }

  const handleSelectButtonClick = async (row) => {
    if(row.gameId) {
      const currentTournamentRound = tournamentsRounds.find(tournamentRound => tournamentRound.number === row.index);

      await updateTournamentsRoundsMutation.mutateAsync({
        roundId: currentTournamentRound?.id,
        gameId: row.gameId
      }).catch((error) => {
        console.error('Error assigning tournament round to game:', error);
        return null;
      });
      
      setRoundRows(prev =>
        prev.map(r =>
          r.name === row.name ? { ...r, updated: true } : r
        )
      );
    }
  }

  const handleConfirmAlertButtonClick = () => {
    setIsAlertVisible(false);
  }

  return (
    <Layout
      isHeaderVisible={true}
      isContentVertical={true}
      className="instructor-onboarding-competition-layout"
      backgroundColor="#FFF8EB"
    >
      <CompetitionHeader
        title="Final Setup: Assign exercise to a round."
        description="You can modify later."
      />
      
      <ReviewsSessionExerciseTable
        rows={roundRows}
        tournamentGames={tournamentGames}
        onSelectChange={handleGameSelectChange}
        onSelectButtonClick={handleSelectButtonClick}
      />

      {
        isAlertVisible &&
          <Alert 
            type="error"
            title="Error"
            text="Oops! You need to select a game for each round to continue."
            confirmButtonText="Ok"
            onConfirmButtonClick={handleConfirmAlertButtonClick}
          />
      }

      <CompetitionFooter
        onBack={handleBackButtonClick}
        nextButtonText="I’m Done"
        onNext={handleImDoneButtonClick}
      />
    </Layout>
  );
}
